import type { Mark } from '../document-types';
import type { MarkHandler } from './types';

export class BoldMark implements MarkHandler {
  readonly type = 'bold';

  apply(text: string, _mark: Mark): string {
    return `**${text}**`;
  }
}
